<template>
  <div>
    <self-back :pageHeaderList="[{ 'name': '账号配置' }]"></self-back>
    <div class="content" v-loading='loading'>
      <div class="clear topBox">
        <div class="left">
          <button class="addaccountButton" @click="addaccountEvent">+ 添加广告主账户</button>
          <el-date-picker style="width:160px;margin-left:10px;vertical-align:middle;" v-model="screenMonth" :clearable='false' type="month"
            size="mini" value-format="yyyy-MM" placeholder="月份筛选">
          </el-date-picker>
          <el-input placeholder="请输入广告主账户" v-model.trim="keyword" clearable
            @keydown.enter.native="keyword ? accountsListEvent(1) : ''" @clear="accountsListEvent(1)" size="mini"
            style="width:200px; margin-left:10px;">
            <el-button slot="append" icon="el-icon-search" @click="keyword ? accountsListEvent(1) : ''"
              style="padding:0 10px"></el-button>
          </el-input>
          <el-input placeholder="请输入账户ID" v-model.trim="account_id" clearable
            @keydown.enter.native="account_id ? accountsListEvent(1) : ''" @clear="accountsListEvent(1)" size="mini"
            style="width:200px; margin-left:10px;">
            <el-button slot="append" icon="el-icon-search" @click="account_id ? accountsListEvent(1) : ''"
              style="padding:0 10px"></el-button>
          </el-input>
          <el-input placeholder="请输入收入上传人" v-model.trim="handler" clearable
            @keydown.enter.native="handler ? accountsListEvent(1) : ''" @clear="accountsListEvent(1)" size="mini"
            style="width:200px; margin-left:10px;">
            <el-button slot="append" icon="el-icon-search" @click="handler ? accountsListEvent(1) : ''"
              style="padding:0 10px"></el-button>
          </el-input>
          <el-input placeholder="请输入成本负责人" v-model.trim="cost_owner" clearable
            @keydown.enter.native="cost_owner ? accountsListEvent(1) : ''" @clear="accountsListEvent(1)" size="mini"
            style="width:200px; margin-left:10px;">
            <el-button slot="append" icon="el-icon-search" @click="cost_owner ? accountsListEvent(1) : ''"
              style="padding:0 10px"></el-button>
          </el-input>
          <el-select
            v-model="selectedPlatformId"
            filterable
            placeholder="请选择平台"
            clearable
            size="mini"
            @change="handlePlatformChange"
            style="width: 200px; margin-left: 10px; vertical-align: middle;">
            <el-option
                v-for="item in platformList"
                :key="item.id"
                :label="item.platform_name"
                :value="item.id">
            </el-option>
        </el-select>
        </div>
        <div class="right">
          <a style="font-size: 13px;margin-right: 10px;text-decoration: underline;"
            href="https://order-consumption-system.oss-cn-beijing.aliyuncs.com/h5/account_configure.xlsx?v=1">点击下载导入模板</a>
          <el-upload style="display:inline-block;" ref="upload" :action="URL.BASEURL + URL.uploadAccount"
            :on-success="uploadSuccess" :on-error="uploadError" :data="uploadFileData" :show-file-list='false'
            :auto-upload="true" accept=".csv,.xls,.xlsx">
            <button class="lianjie">导入数据</button>
          </el-upload>
        </div>
      </div>
      <el-table class="table" :header-cell-style="{ background: '#f5f7fa' }" :data="accountList"
        :max-height="tableMaxHeight" border>
        <el-table-column prop="advertiser_account" label="广告主账户" align='center'></el-table-column>
        <el-table-column prop="advertiser_id" align='center' label="账户ID"></el-table-column>
        <el-table-column prop="account_budget" align='center' label="账户消耗成本"></el-table-column>
        <el-table-column prop="cost" align='center' label="当月消耗合计"></el-table-column>
        <el-table-column prop="balance" align='center' label="差值"></el-table-column>
        <el-table-column prop="type" align='center' label="平台"></el-table-column>
        <el-table-column prop="handler_list" align='center' label="收入上传人"></el-table-column>
        <el-table-column prop="cost_owner_list" align='center' label="成本负责人"></el-table-column>
        <el-table-column prop="operator" align='center' label="账户操作人"></el-table-column>
        <el-table-column prop="month_format" align='center' label="日期"></el-table-column>
        <el-table-column align='center' width='160' label="操作">
          <template slot-scope="scope">
            <button @click="modifyaccountEvent(scope.row)">修改</button>
            <button v-if="scope.row.del_enable == 1" style="background:#FC726D"
              @click="deleteaccountFlagEvent(scope.row)">删除</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paginationBox" style="height: 30px;">
        <el-pagination small background @current-change="handleCurrentChange" :current-page="page"
          :page-size="page_size" layout="total, prev, pager, next, jumper" :total="total" />
      </div>
    </div>
    <!-- 添加账号 -->
    <el-dialog :title="isEdit ? '修改账号' : '添加账号'" :visible.sync="addaccountFlag" width="30%"
      :close-on-click-modal='false' center>
      <div class="dialogBox">
        <div class="dialogitem">
          <label><em>*</em>广告主账户：</label>
          <el-input placeholder="请输入广告主账户" style="width:60%" v-model.trim="accountName" size='small' clearable>
          </el-input>
        </div>
        <div class="dialogitem">
          <label><em>*</em>账户ID：</label>
          <el-input placeholder="请输入账户ID" style="width:60%" v-model.trim="advertiser_id" size='small' clearable>
          </el-input>
        </div>
        <!-- <div class="dialogitem">
                    <label><em>*</em>广告主名称：</label>
                    <el-input
                        :disabled="isEdit?true:false"
                        placeholder="请输入广告主名称"
                        style="width:60%"
                        v-model.trim="advertiser_name"
                        size='small'
                        clearable>
                    </el-input>
                </div>
                <div class="dialogitem">
                    <label>公司名称：</label>
                    <el-input
                        placeholder="请输入公司名称"
                        style="width:60%"
                        v-model.trim="companyName"
                        size='small'
                        clearable>
                    </el-input>
                </div> -->
        <div class="dialogitem">
          <label>账户消耗成本：</label>
          <el-input placeholder="请输入账户消耗成本" style="width:60%" v-model.trim="budget"
            @input="(val) => { budget = budget.replace(/[^\d|.]/g, '') }" size='small' clearable>
          </el-input>
        </div>
        <div class="dialogitem">
          <label><em>*</em>平台：</label>
          <el-select class="input" v-model="platform_type" size='mini' filterable placeholder="请选择平台">
            <el-option v-for="(item, index) in platformList" :key="index" :label="item.platform_name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="dialogitem">
          <label><em>*</em>时间：</label>
          <el-date-picker :disabled="isEdit ? true : false" style="width:56%" v-model="timeMonth" type="month"
            size="mini" value-format="yyyy-MM" placeholder="选择时间">
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAddaccount" size="mini">取 消</el-button>
        <el-button type="primary" @click="addaccountYes" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      uploadFileData: {
        admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
        ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
        sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign
      },
      addaccountFlag: false,
      deleteaccountFlag: false,
      accountList: [],
      accountName: '',
      page: 1,
      page_size: 20,
      total: 0,
      loading: false,
      isEdit: false,
      vebateId: '',
      advertiser_id: '',
      budget: '',
      timeMonth: '',
      screenMonth: '',
      keyword: '',
      platformList: [],
      platform_type: '',
      account_id: '',
      handler: '',
      cost_owner: '',
      selectedPlatformId: ''
    }
  },
  computed: {
    // 计算表格最大高度，确保分页控件可见
    tableMaxHeight() {
      // Header(60) + self-back(50) + padding(30) + topBox(80) + table-margin(15) + pagination(40) + pagination-margin(15) + footer(70) + footer-margin(10) = 370px
      return window.innerHeight - 260;
    }
  },
  created () {
    var date = new Date();
    let month = ((date.getMonth()) <= 9 ? ('0' + (date.getMonth())) : (date.getMonth()));
    this.screenMonth = month == '00' ? ((date.getFullYear() - 1) + '-12') : (date.getFullYear() + '-' + month);
    this.platformEvent()
    this.accountsListEvent(1)
  },
  methods: {
    handlePlatformChange(value) {
        this.page = 1;
        this.accountsListEvent(1);
    },
    platformEvent () {
      this.$axios.get(this.URL.BASEURL + this.URL.platformList, {
        params: {
          page: 1,
          page_size: 555,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.platformList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    uploadSuccess (res, file, fileList) {
      if (res.errno == 0) {
        this.accountsListEvent(this.page)
        this.$message({
          message: '导入成功',
          type: 'success'
        })
      } else {
        this.$alert("有误字段：第" + res.rst.error[0].row + '行：' + res.rst.error[0].error.join(','), res.err, {
          confirmButtonText: '确定',
          callback: action => {

          }
        });
      }

    },
    uploadError (err, file, fileList) {
      this.$message({
        message: '导入失败',
        type: 'fail'
      })
    },
    addaccountEvent () {//点击添加账号按钮
      this.addaccountFlag = true;
      this.isEdit = false;
    },
    deleteaccountFlagEvent (data) {//删除账号
      this.$confirm('确定要删除该配置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.URL.BASEURL + this.URL.accountDel, {
          id: data.id,
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.accountsListEvent(this.page)
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
        })
      }).catch(() => {
      });
    },
    handleCurrentChange (val) {
      this.accountsListEvent(val)
    },
    accountsListEvent (page) {
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.accountList, {
        params: {
          page: page,
          page_size: this.page_size,
          date: this.screenMonth,
          account: this.keyword,
          account_id: this.account_id,
          handler: this.handler,
          cost_owner: this.cost_owner,
          launch_platform_id: this.selectedPlatformId === '0' ? '' : this.selectedPlatformId
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.accountList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    addaccountYes () {//添加账号
      if (this.accountName == '') {
        this.$message({
          message: '请输入广告主账户名称',
          type: 'fail'
        })
        return
      }
      if (this.advertiser_id == '') {
        this.$message({
          message: '请输入账户ID',
          type: 'fail'
        })
        return
      }
      if (this.timeMonth == '') {
        this.$message({
          message: '请选择时间',
          type: 'fail'
        })
        return
      }
      if (this.platform_type == '') {
        this.$message({
          message: '请选择平台',
          type: 'fail'
        })
        return
      }
      if (this.isEdit) {//编辑
        this.$axios.post(this.URL.BASEURL + this.URL.accountEdit, {
          id: this.vebateId,
          advertiser_account: this.accountName,
          // advertiser_name: this.advertiser_name,
          // company:this.companyName,
          advertiser_id: this.advertiser_id,
          account_budget: this.budget,
          type: this.platform_type
          // month: this.timeMonth
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.accountsListEvent(this.page)
            this.cancelAddaccount()
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
        })
      } else {
        this.$axios.post(this.URL.BASEURL + this.URL.accountAdd, {
          advertiser_account: this.accountName,
          // advertiser_name: this.advertiser_name,
          // company: this.companyName,
          advertiser_id: this.advertiser_id,
          account_budget: this.budget,
          type: this.platform_type,
          month: this.timeMonth
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.accountsListEvent(this.page)
            this.cancelAddaccount()
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
        })
      }
    },
    cancelAddaccount () {//取消添加账号
      this.addaccountFlag = false;
      this.accountName = '';
      // this.companyName = '';
      // this.advertiser_name = '';
      this.advertiser_id = '';
      this.timeMonth = '';
      this.platform_type = '';
      this.budget = '';
      this.isDefault = false;
    },
    modifyaccountEvent (data) {//修改账号
      this.accountName = data.advertiser_account;
      this.vebateId = data.id;
      // this.companyName = data.company;
      // this.advertiser_name = data.advertiser_name;
      this.advertiser_id = data.advertiser_id;
      this.budget = data.account_budget;
      this.timeMonth = (data.month_format.replace(/\年/g, '-')).replace(/\月/g, '');
      this.platform_type = data.type == '快手' ? 1 : (data.type == '抖音' ? 2 : '')
      this.isEdit = true;
      this.addaccountFlag = true;
    }
  },
  watch: {
    screenMonth () {
      this.accountsListEvent(1)
    },
    addaccountFlag () {
      if (!this.addaccountFlag) {
        this.cancelAddaccount()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
  padding: 15px 15px 15px;
  // display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-height: calc(100vh - 140px);
  .topBox {
    flex-shrink: 0;
  }
  .addaccountButton {
    height: 30px;
    background: #5b7bfe;
    border-radius: 4px;
    color: #ffffff;
    font-size: 13px;
    border: none;
    padding: 0 10px;
  }

  .filterBox {
        display: flex;
        align-items: center;
    }

  .table {
    margin-top: 15px;
    flex: 1;
    min-height: 0;

    button {
      min-width: 48px;
      height: 22px;
      background: #5b7bfe;
      border-radius: 4px;
      color: #ffffff;
      font-size: 12px;
      border: none;
      padding: 0 6px;
    }
  }
  .paginationBox {
    flex-shrink: 0;
    margin-top: 15px;
    padding-bottom: 0;
  }
}

.dialogitem {
  margin-bottom: 20px;

  &:last-of-type {
    margin-bottom: 0;
  }

  label {
    display: inline-block;
    width: 110px;
    color: #202652;
    font-size: 14px;
    line-height: 20px;

    em {
      color: red;
    }
  }
}

.topBox {
  .left {
    float: left;
    display: flex;
    align-items: center;
  }

  .right {
    float: right;

    .lianjie {
      background: #5c7bfe;
      border: none;
      color: #ffffff;
      font-size: 12px;
      line-height: 30px;
      border-radius: 4px;
      padding: 0 8px;

      a {
        color: #ffffff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/disposeAdmin/accountConfigure.vue